import { useContext } from "react";

import { ErrorsAndWarningsContext } from "@/contexts/errors-and-warnings";

export const useErrorsAndWarnings = () => useContext(ErrorsAndWarningsContext);
